// extracted by mini-css-extract-plugin
export var gallery = "gallery-module--gallery--16JeD";
export var title = "gallery-module--title--358Go";
export var grid = "gallery-module--grid--18WSB";
export var row = "gallery-module--row--R8bQj";
export var column = "gallery-module--column--xZISJ";
export var layout1Across = "gallery-module--layout1Across--2Y96r";
export var layout2Across = "gallery-module--layout2Across--2g7Kb";
export var layout3Across = "gallery-module--layout3Across--3bjrp";
export var layout4Across = "gallery-module--layout4Across--3kAsa";
export var imageContainer = "gallery-module--imageContainer--1cLEj";
export var image = "gallery-module--image--19Apw";
export var gatsbyImage = "gallery-module--gatsbyImage--3J79c";
export var tags = "gallery-module--tags--3q25Y";